export default __webpack_public_path__ + "static/media/3team.8e2c9ad9.jpeg";